import { ApiEndpoints } from './../constant';
import { Component, OnInit } from '@angular/core';
import { CookieManagerService, HttpClientService } from '../../shared';
import { CommonService } from '../staff';
import { CookieNames } from '../constant';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.css']
})
export class LeaderboardComponent implements OnInit {

  public firstwinners = [];
  public secondwinners = [];
  public winner: any; a;
  public isDialogNo: boolean;
  public showTopten: boolean;
  public username: '';
  public userPerformance;

  constructor(
    private cookieManagerService: CookieManagerService,
    private commonService: CommonService,
    private router: Router,
    private httpClientService: HttpClientService
  ) { }

  ngOnInit() {

    var userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    var user = userObj ? JSON.parse(userObj.toString()) : null;
    this.username = user ? user.username : '';
    if (!user) {
      this.isDialogNo = true;
      this.showTopten = true;
    }
    else {
      this.showTopten = false;
      if (this.commonService.isDialogMobileNumber(user.username)) {
        this.isDialogNo = true;
      }
      else {
        this.isDialogNo = false;
      }
    this.getMyPerformance(user._id);
    }

    this.fetchWeeklyCompetitor();

  }

  showSubscribePopup() {
    $('#packages-pop').modal('show');
  }

  toggleTopten(value) {
    if (!value) {
      var userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
      var user = userObj ? JSON.parse(userObj.toString()) : null;
      this.username = user ? user.username : '';
      if (this.username) {
        this.getMyPerformance(user._id);
        this.showTopten = value;
      }
      else {
        $('#log-in-pop').modal('show');
        this.showTopten = true;
      }
    }
    else {
      this.showTopten = value;
    }
  }

  goToHomePage() {
    this.router.navigate(['home/exams']);
  }

  fetchWeeklyCompetitor() {
    this.httpClientService.authGet(ApiEndpoints.getTopTenWinners, null).subscribe(response => {
      this.firstwinners = [];
      this.secondwinners = [];
      if (response && response.length > 0) {
        response.forEach((element, index) => {
          if (index < 10) {
            this.firstwinners.push(element);
          }
          else {
            this.secondwinners.push(element);
          }
        });
      }
    });
  }

  getMyPerformance(userId) {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getUserPerformances, { [ApiEndpoints.userid]: userId }), null).subscribe(response => {
      if (response) {
        this.userPerformance = response[0];
      }
    });
  }
}




// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/leaderboard/leaderboard.component.ts